import { CircularProgress, Paper, Stack, Typography } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { startListApi } from '../../api/startListApi';
import { StartListHeatsView } from './StartListHeatsView';

interface Props {
  disciplineId: number;
}

/**
 * Verejny pohled na startovku per disciplina.
 * Zobrazi vsechny start_list_groups dane discipliny + jejich rozbehy/drahy (read-only).
 */
export function PublicDisciplineStartList({ disciplineId }: Props) {
  const { data: groups = [], isLoading } = useQuery({
    queryKey: ['public-start-list-groups', disciplineId],
    queryFn: () => startListApi.publicFindByDiscipline(disciplineId),
    enabled: !!disciplineId,
    refetchInterval: 30_000,
  });

  if (isLoading) {
    return (
      <Stack alignItems="center" sx={{ py: 4 }}>
        <CircularProgress size={32} />
      </Stack>
    );
  }

  if (groups.length === 0) {
    return null; // Bez startovni skupiny nezobrazuj nic (sekce zmizí)
  }

  return (
    <Stack spacing={3}>
      {groups.map((group) => (
        <PublicStartListGroupView key={group.id} groupId={group.id} groupName={group.name} />
      ))}
    </Stack>
  );
}

function PublicStartListGroupView({
  groupId,
  groupName,
}: {
  groupId: number;
  groupName: string;
}) {
  const { data: startList, isLoading } = useQuery({
    queryKey: ['public-start-list', groupId],
    queryFn: () => startListApi.publicGetStartList(groupId),
    enabled: !!groupId,
    refetchInterval: 30_000,
  });

  if (isLoading) {
    return (
      <Stack alignItems="center" sx={{ py: 2 }}>
        <CircularProgress size={24} />
      </Stack>
    );
  }
  if (!startList || startList.heats.length === 0) {
    return null;
  }

  return (
    <Paper variant="outlined" sx={{ p: 2 }}>
      <Typography variant="subtitle1" fontWeight={700} sx={{ mb: 1 }}>
        {groupName}
      </Typography>
      <StartListHeatsView startList={startList} editable={false} />
    </Paper>
  );
}
